import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _assertThisInitialized from "@babel/runtime/helpers/assertThisInitialized";
import _inherits from "@babel/runtime/helpers/inherits";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";
import _defineProperty from "@babel/runtime/helpers/defineProperty";

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

import React, { Component } from 'react';
import { translate, Button } from '@haldor/ui';
import { connect } from 'react-redux';
import '../_onboarding.scss';

var SelectConsentWay = /*#__PURE__*/function (_Component) {
  _inherits(SelectConsentWay, _Component);

  var _super = _createSuper(SelectConsentWay);

  function SelectConsentWay(props) {
    var _this;

    _classCallCheck(this, SelectConsentWay);

    _this = _super.call(this, props);

    _defineProperty(_assertThisInitialized(_this), "goBack", function () {
      return new Promise(function (resolve) {
        if (_this.props.onSubmit) {
          _this.props.onSubmit(0).then(function () {
            resolve(1);
          });
        }
      });
    });

    _this.state = {};
    return _this;
  }

  _createClass(SelectConsentWay, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      if (this.props.adminInvitations != null && this.props.adminInvitations.length > 0 && this.props.onboardingUser != null) {
        if (this.props.adminInvitations.sentByMe) {
          this.props.showPage('waitingForResponse');
        }
      }
    }
  }, {
    key: "showConsentHeader",
    value: function showConsentHeader() {
      return /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement("h2", {
        style: {
          textAlign: 'left'
        }
      }, this.props.translate('Want to access more functionality?')), /*#__PURE__*/React.createElement("p", {
        style: {
          textAlign: 'left',
          marginTop: '1rem',
          marginBottom: '1rem'
        }
      }, this.props.translate('An admin\'s approval is needed. Don\'t worry, we\'ve prepared an email for you to send. Just open the email suggestion below to get started!')), /*#__PURE__*/React.createElement("div", {
        style: {
          width: '20rem',
          marginBottom: '2rem'
        }
      }, /*#__PURE__*/React.createElement("img", {
        src: "/dist/svg/illustration_steg02.svg"
      })));
    }
  }, {
    key: "showConsentButtonGroup",
    value: function showConsentButtonGroup() {
      var _this2 = this;

      return /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement(Button, {
        type: "primary",
        style: {
          marginRight: '0.5rem'
        },
        onClick: function onClick() {
          _this2.props.showPage('showEmailInfo');
        }
      }, this.props.translate('Open e-mail suggestion'), " "), /*#__PURE__*/React.createElement(Button, {
        type: "secondary",
        style: {
          marginRight: '0.5rem'
        },
        onClick: function onClick() {
          _this2.props.showPage('navigateToAdminConsent');
        }
      }, this.props.translate('I am an Office 365-admin'), " "));
    }
  }, {
    key: "render",
    value: function render() {
      return /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement("div", null, this.showConsentHeader(), /*#__PURE__*/React.createElement("div", {
        style: {
          display: "flex",
          alignItems: "left",
          justifyContent: "left"
        }
      }, this.showConsentButtonGroup())));
    }
  }]);

  return SelectConsentWay;
}(Component);

function mapStateToProps(state) {
  return {
    translate: translate(state.Languages.translations),
    adminInvitations: state.Services.adminInvitations,
    onboardingUser: state.user.onboardingUser
  };
}

export default connect(mapStateToProps, {})(SelectConsentWay);